import { IndexerTierResult } from "../web3/Types";
import { USDC } from "./UsdcValue";
import { Set } from "./Set";

export class PrizeTierResults {
  index: number;
  combination: Set;
  prizePerWinner: USDC;
  prizeFundAmount: USDC;
  totalWinners: bigint;

  constructor(
    index: number,
    combination: Set,
    prizePerWinner: USDC,
    prizeFundAmount: USDC,
    totalWinners: bigint,
  ) {
    this.index = index;
    this.combination = combination;
    this.prizePerWinner = prizePerWinner;
    this.prizeFundAmount = prizeFundAmount;
    this.totalWinners = totalWinners;
  }

  static fromGraphQL(data: IndexerTierResult): PrizeTierResults {
    const index = Number(data.index);
    const combination = new Set(
      Number(data.tier_mainNumber),
      Number(data.tier_luckyStar),
    );
    const prizePerWinner = new USDC(data.prizePerWinner);
    const prizeFundAmount = new USDC(data.prize);
    const totalWinners = data.winningTickets;
    return new PrizeTierResults(
      index,
      combination,
      prizePerWinner,
      prizeFundAmount,
      totalWinners,
    );
  }

  toString(): string {
    return `Combination: ${this.combination.toString()}, Prize Per Winner: ${this.prizePerWinner.toString()}, Prize Fund Amount: ${this.prizeFundAmount.toString()}, Total Winners: ${this.totalWinners.toString()}`;
  }
}
